<!-- eslint-disable vue/max-attributes-per-line -->
<template>
  <v-container>
    <div class="d-flex align-center justify-space-between mb-4">
      <h1>日報β設定</h1>
      <v-btn
        color="primary"
        :ripple="false"
        :to="{ name: 'daily-report-summary' }"
      >
        日報β画面へ
      </v-btn>
    </div>

    <!-- ローディング中 -->
    <v-skeleton-loader
      v-if="sectionCount === null"
      type="table"
    />

    <!-- セクションなし時の空状態 -->
    <div
      v-else-if="sectionCount === 0"
      class="d-flex flex-column align-center justify-center"
      style="min-height: 300px;"
    >
      <div class="text-body-1 grey--text mb-6">
        まだデータがありません
      </div>
      <v-btn
        color="primary"
        :ripple="false"
        @click="createTemplate"
      >
        テンプレート自動作成
      </v-btn>
    </div>

    <!-- セクション管理（直接表示） -->
    <report-sections
      ref="reportSections"
      v-show="sectionCount > 0"
      @metric-click="onMetricClick"
      @open-metrics="metricsDialogOpen = true"
      @open-formula-items="formulaItemsDialogOpen = true"
      @loaded="sectionCount = $event"
    />

    <!-- 指標管理モーダル -->
    <v-dialog v-model="metricsDialogOpen" max-width="1400" scrollable>
      <v-card>
        <v-card-title class="d-flex justify-space-between">
          指標管理
          <v-btn icon @click="metricsDialogOpen = false"><v-icon>{{ icons.mdiClose }}</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <report-metrics v-if="metricsDialogOpen" />
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- 計測項目管理モーダル -->
    <v-dialog v-model="formulaItemsDialogOpen" max-width="1400" scrollable>
      <v-card>
        <v-card-title class="d-flex justify-space-between">
          計測項目管理
          <v-btn icon @click="formulaItemsDialogOpen = false"><v-icon>{{ icons.mdiClose }}</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <report-formula-items v-if="formulaItemsDialogOpen" />
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- セクションから指標クリック時の計測項目モーダル -->
    <report-metric-items-dialog
      v-model="metricItemsDialogOpen"
      :metric-id="selectedMetricId"
      :metric-name="selectedMetricName"
    />
  </v-container>
</template>

<script>
import { ref, getCurrentInstance } from '@vue/composition-api'
import { mdiClose } from '@mdi/js'
import ReportFormulaItems from '@/views/v2-temp/report-formula-items/index.vue'
import ReportSections from '@/views/v2-temp/report-sections/index.vue'
import ReportMetrics from '@/views/v2-temp/report-metrics/index.vue'
import ReportMetricItemsDialog from '@/views/v2-temp/report-metric-items/ReportMetricItemsDialog.vue'
import ReportTemplateApi from '@/api/v1/admin/ReportTemplate'

export default {
  components: {
    ReportFormulaItems,
    ReportSections,
    ReportMetrics,
    ReportMetricItemsDialog,
  },
  setup() {
    const instance = getCurrentInstance().proxy
    const metricsDialogOpen = ref(false)
    const formulaItemsDialogOpen = ref(false)
    const metricItemsDialogOpen = ref(false)
    const selectedMetricId = ref(null)
    const selectedMetricName = ref('')
    const sectionCount = ref(null)

    const onMetricClick = ({ metricId, metricName }) => {
      selectedMetricId.value = metricId
      selectedMetricName.value = metricName
      metricItemsDialogOpen.value = true
    }

    const createTemplate = async () => {
      try {
        await ReportTemplateApi.create()
        // eslint-disable-next-line no-underscore-dangle
        instance.$refs.reportSections.fetchItems()
      } catch (e) {
        // TODO
      }
    }

    return {
      metricsDialogOpen,
      formulaItemsDialogOpen,
      metricItemsDialogOpen,
      selectedMetricId,
      selectedMetricName,
      onMetricClick,
      createTemplate,
      sectionCount,
      icons: { mdiClose },
    }
  },
}
</script>

